import { classNames } from '@dimjs/utils';
import { getStrByteLen, isUndefinedOrNull } from '@flatbiz/utils';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from '../../modal';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../../utils';
import { dialogAlert } from '../alert';
import './style.less';

interface DialogToastProps {
  message: string;
  status?: 'success' | 'error' | 'warn';
  onClose?: () => void;
  duration?: number | false;
  hideMask?: boolean;
  className?: string;
}

const ModalRender = (props: DialogToastProps & BodyAppendDivElementProps) => {
  const { duration, elementId, ...otherProps } = props;
  const [visible, setVisible] = useState(false);

  const onClose = hooks.useCallbackRef(() => {
    setVisible(false);
    props.onClose?.();
  });

  useEffect(() => {
    setVisible(true);
  }, []);

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${elementId}`);
  });
  const onAfterOpen = hooks.useCallbackRef(() => {
    setTimeout(() => {
      onClose();
    }, duration || 2000);
  });

  const onMaskClick = hooks.useCallbackRef(() => {
    if (!props.onClose) {
      setVisible(false);
    }
  });

  return (
    <Modal
      {...otherProps}
      visible={visible}
      getContainer={props.divElement}
      onClose={onClose}
      onAfterClose={onAfterClose}
      onAfterOpen={onAfterOpen}
      destroyOnClose={true}
      className={classNames('v-dialog-toast', props.className)}
      onMaskClick={onMaskClick}
      mask={!props.hideMask}
      bodyClassName={classNames({ [`v-dialog-toast-${props.status}`]: props.status })}
    >
      {props.status && <div className="v-dialog-toast-icon"></div>}
      <div className="v-dialog-toast-message">{props.message}</div>
    </Modal>
  );
};

type DialogToastConfig = {
  moreShowAlert?: boolean;
  moreLength?: number;
};

export const dialogToast = (props: DialogToastProps) => {
  const dialogToastConfig = (window['dialogToastConfig'] || {}) as DialogToastConfig;
  const message = props.message || '';
  const moreShowAlert = isUndefinedOrNull(dialogToastConfig.moreShowAlert)
    ? true
    : dialogToastConfig.moreShowAlert;
  const moreLength = (
    isUndefinedOrNull(dialogToastConfig.moreLength) ? 28 : dialogToastConfig.moreLength
  ) as number;
  if (moreShowAlert && getStrByteLen(message) >= moreLength) {
    dialogAlert({ content: message, btnName: '关闭' });
    return;
  }

  const { divElement, elementId } = bodyAppendDivElement();
  ReactDOM.render(<ModalRender {...props} divElement={divElement} elementId={elementId} />, divElement);
};
